module.exports = __webpack_public_path__ + "static/tunic-85348cc0e3d8a0e0024b997330f0c905.webp";